import React, { ReactNode } from 'react';
import { Box, Button } from '@mui/material';
import { MdAddCircleOutline } from 'react-icons/md';

/** Keeps section action buttons right-aligned with matching icon position. */
export interface SectionHeaderRowProps {
  left: ReactNode;
  action: ReactNode;
}

const ACTION_BUTTON_WIDTH = '10.75rem';

export interface SectionAddButtonProps {
  label: string;
  onClick: (e: React.MouseEvent) => void;
}

export function SectionAddButton({ label, onClick }: SectionAddButtonProps) {
  return (
    <Button
      variant="text"
      className="rounded-lg"
      onClick={onClick}
      startIcon={<MdAddCircleOutline size={20} />}
      sx={{
        width: ACTION_BUTTON_WIDTH,
        minWidth: ACTION_BUTTON_WIDTH,
        justifyContent: 'flex-start',
        textTransform: 'none',
        px: 0.5,
        py: 0.5,
        '& .MuiButton-startIcon': {
          marginRight: '6px',
          marginLeft: 0,
        },
      }}
    >
      {label}
    </Button>
  );
}

function SectionHeaderRow({ left, action }: SectionHeaderRowProps) {
  return (
    <Box className="flex items-center justify-between pb-1">
      <Box className="flex min-w-0 flex-1 items-center">
        {left}
      </Box>
      <Box
        className="flex shrink-0 items-center justify-end"
        sx={{ width: ACTION_BUTTON_WIDTH, minWidth: ACTION_BUTTON_WIDTH }}
      >
        {action}
      </Box>
    </Box>
  );
}

export default SectionHeaderRow;
